import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	CContainer,
	CHeader,
	CHeaderNav,
	CNavItem
} from '@coreui/react-pro';
import { SunIcon, MoonIcon } from '@phosphor-icons/react';
import ClientSelector from './utils/ClientSelector';
import { isAdminUser, isEndUser, isMSSPAdmin, isReadOnly } from '../utils/rights';
import AppHeaderDropdown from './AppHeaderDropdown';
import { CUSTOMER_SELECTED } from 'src/actions';
import PlatformWaffle from './waffle-menu/PlatformWaffle';
import { useTheme } from '../context/ThemeContext';


const AppHeader = () => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.user?.userData?.user);
	const customer = useSelector((state) => state.user?.userData?.customer);
	const sidebarShow = useSelector((state) => state.app.sidebarShow);
	const { theme: appTheme, toggleTheme } = useTheme();

	useEffect(() => {
		if (isEndUser(user) || isReadOnly(user)) {
			dispatch({
				type: CUSTOMER_SELECTED,
				payload: customer
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	const canChangeClient = () => isAdminUser(user) || isMSSPAdmin(user);

	return (
		<React.Fragment>
			
			<CHeader position='sticky' className={`mb-4 header-container${sidebarShow ? '' : ' collapsed'}`}>
				<CContainer fluid>

					<CHeaderNav className='d-none d-md-flex me-auto'>
					<CNavItem />
				</CHeaderNav>
				<CHeaderNav className="me-auto d-flex align-items-center" />
					<CHeaderNav className="d-flex align-items-center">
						{canChangeClient() ? <ClientSelector /> : null}
						{isReadOnly(user) && (
							<span className="readonly-banner-inline">
								&#128274; Read-Only Mode
							</span>
						)}
						<button
							className="theme-toggle-btn ms-2"
							onClick={toggleTheme}
							title={appTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
							aria-label="Toggle theme"
						>
							{appTheme === 'dark' ? <SunIcon weight="bold" size={20} /> : <MoonIcon weight="bold" size={20} />}
						</button>
						<div className="ms-2 me-3">
							<PlatformWaffle />
						</div>
						<AppHeaderDropdown />
					</CHeaderNav>
				</CContainer>
			</CHeader>
		</React.Fragment>
	);
};

export default AppHeader;
